import React from 'react';
import { HamburgerButton, TopBar } from './styles';

const HamburgerMenu = ({ isOpen, toggleMenu }) => {
  return (
    <TopBar>
      <HamburgerButton 
        className={`hamburger-menu ${isOpen ? 'open' : ''}`} 
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        <span/>
        <span/>
        <span/>
      </HamburgerButton>
    </TopBar>
  );
};

export default HamburgerMenu;
